import styled from 'styled-components';

export const ContainerMeuPlano = styled.section`
  width: 100%;
  height: 100%;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;

  .meu-plano-expirado {
    flex: 1;
    min-height: 28rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .meu-plano-expirado-card {
    max-width: 38rem;
    width: 100%;
    padding: 2rem;
    border-radius: 0.75rem;
    border: 0.0625rem solid #e5e7eb;
    background: #ffffff;
    box-shadow: 0 0.75rem 2rem rgba(15, 23, 42, 0.08);

    h2 {
      margin: 0;
      color: #57069e;
      font-size: 1.5rem;
      font-weight: 700;
    }

    p {
      margin: 1rem 0 0;
      color: #374151;
      font-size: 1.125rem;
      line-height: 1.6;
    }

    strong {
      color: #111827;
    }
  }

  .meu-plano-dashboard {
    display: grid;
    /* grid-template-columns: minmax(0, 1.75fr) minmax(20rem, 0.95fr); */
    gap: 1.5rem;
    align-items: stretch;
    width: 100%;
  }

  .meu-plano-slot {
    min-width: 0;
    display: flex;
  }

  .meu-plano-slot > * {
    width: 100%;
    height: 100%;
  }

  .meu-plano-slot--current {
    min-height: 13.75rem;
  }

  .meu-plano-slot--plans {
    min-height: 13.75rem;
  }

  .meu-plano-single-view {
    width: 100%;
    min-width: 0;
  }

  .meu-plano-single-view > * {
    width: 100%;
  }

  @media (max-width: 1100px) {
    .meu-plano-dashboard {
      grid-template-columns: 1fr;
    }

    .meu-plano-slot--current,
    .meu-plano-slot--plans {
      min-height: auto;
    }
  }

  @media (max-width: 768px) {
    .meu-plano-dashboard {
      gap: 1rem;
    }
  }
`;
